import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { OrderType } from 'hooks/useOrderType';

interface AppStoreState {
  orderType: OrderType | null;
  setOrderType: (orderType: OrderType) => void;
  clearOrderType: () => void;
}

export const useAppStore = create<AppStoreState>()(
  persist(
    (set) => ({
      orderType: null,
      setOrderType: (orderType) => set({ orderType }),
      clearOrderType: () => set({ orderType: null }),
    }),
    {
      name: 'app-store  ', // unique name for localStorage
      partialize: (state) => ({ orderType: state.orderType }),
    }
  )
);
